var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { HttpClientWrapper } from './httpClient';
import { SharedService } from './shared.service';
var UuidParteService = (function (_super) {
    __extends(UuidParteService, _super);
    function UuidParteService(_http) {
        var _this = _super.call(this) || this;
        _this._http = _http;
        return _this;
    }
    UuidParteService.prototype.findUuidPar = function (codigo) {
        var wsUrl = this.urlPublic() + "uuidparte/" + codigo;
        return this._http.getPublic(wsUrl)
            .map(function (response) { return response.json(); });
    };
    return UuidParteService;
}(SharedService));
UuidParteService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [HttpClientWrapper])
], UuidParteService);
export { UuidParteService };
//# sourceMappingURL=uuidparte.service.js.map